module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_5010.7ac52222.png";